/* ╔══════════════════════════════════════════════════════════════════╗
   ║  BRONZATA Ann + Header — JS                                      ║
   ║  - Announcement bar: auto-rotate messages every 3s               ║
   ║  - Header: auto-hide on scroll-down, show on scroll-up           ║
   ║  - Cart count: dynamic via /cart.js + listen to cart events      ║
   ║  - Mobile drawer: open/close                                     ║
   ╚══════════════════════════════════════════════════════════════════╝ */

(function () {
  'use strict';

  /* ─── Announcement bar rotation ─────────────────────────────── */
  function initAnnRotation() {
    const msgs = document.querySelectorAll('.bz-ann-bar__msg');
    if (msgs.length < 2) return;
    let i = 0;
    msgs[0].classList.add('is-active');
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 3000);
  }

  /* ─── Header auto-hide on scroll (Headroom-style, position fixed) ───
     Fixed header that follows the ann bar at the very top, then sticks
     to viewport top once the ann bar is scrolled past. Translate3d
     hide/show on scroll direction — battle-tested for mobile Safari. */
  function initHeaderScroll() {
    const header = document.querySelector('.bz-header');
    const annBar = document.querySelector('.bz-ann-bar');
    if (!header) return;
    const annH = annBar ? annBar.offsetHeight : 0;
    const PIN_THRESHOLD = annH + 40; // always visible until past this
    let lastY = window.scrollY < 0 ? 0 : window.scrollY;
    let ticking = false;

    function setTop(px) {
      header.style.top = px + 'px';
    }

    function onScroll() {
      let y = window.scrollY;
      if (y < 0) y = 0; // iOS rubber-band

      // Follow ann bar at very top (so header sits below it)
      if (y <= annH) {
        setTop(annH - y);
      } else {
        setTop(0);
      }

      // Always show near top
      if (y < PIN_THRESHOLD) {
        header.classList.remove('is-hidden');
        lastY = y;
        ticking = false;
        return;
      }

      // Direction-based hide/show
      if (y > lastY) {
        header.classList.add('is-hidden');
      } else if (y < lastY) {
        header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }

    function tick() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('touchmove', tick, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Run once to set initial top
    onScroll();
  }

  /* ─── Cart count dynamic ─────────────────────────────────────── */
  function initCartCount() {
    const badge = document.querySelector('.bz-cart-count');
    if (!badge) return;

    function render(count, isBump) {
      const n = Math.max(0, Number(count) || 0);
      badge.textContent = n > 99 ? '99+' : n;
      if (n > 0) {
        badge.classList.add('is-visible');
      } else {
        badge.classList.remove('is-visible', 'is-bump');
      }
      if (isBump && n > 0) {
        badge.classList.remove('is-bump');
        // force reflow to restart animation
        void badge.offsetWidth;
        badge.classList.add('is-bump');
      }
    }

    function fetchCount(isBump) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d) render(d.item_count, isBump); })
        .catch(() => {});
    }

    // Initial fetch
    fetchCount(false);

    // Listen for cart change events (multiple naming conventions for theme compatibility)
    const evts = [
      'cart:add', 'cart:added', 'cart:change', 'cart:changed',
      'cart:update', 'cart:updated', 'cart:refresh', 'cart-drawer:open',
      'cart:open', 'cart:items:change'
    ];
    evts.forEach(e => document.addEventListener(e, () => fetchCount(true)));
    window.addEventListener('focus', () => fetchCount(false));

    // Intercept fetch calls to /cart/add.js and /cart/update.js
    if (window.fetch) {
      const _fetch = window.fetch;
      window.fetch = function () {
        const url = arguments[0];
        const isCart = typeof url === 'string' && /\/cart\/(add|update|change|clear)\.js/.test(url);
        const p = _fetch.apply(this, arguments);
        if (isCart) {
          p.then(() => setTimeout(() => fetchCount(true), 120)).catch(() => {});
        }
        return p;
      };
    }
  }

  /* ─── Mobile drawer ──────────────────────────────────────────── */
  function initDrawer() {
    const ham = document.querySelector('.bz-header__hamburger');
    const drawer = document.querySelector('.bz-drawer');
    const backdrop = document.querySelector('.bz-drawer-backdrop');
    const closeBtn = document.querySelector('.bz-drawer__close');
    const closeX = document.querySelector('.bz-drawer__close-x');
    if (!ham || !drawer || !backdrop) return;

    function open() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    ham.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (closeX)   closeX.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
    });
  }

  /* ─── Init all on DOMContentLoaded ───────────────────────────── */
  function init() {
    initAnnRotation();
    initHeaderScroll();
    initCartCount();
    initDrawer();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
